import WebRequest from './client/WebRequest.js';
import { queryString } from './query-string.js';
import { QueryKeys } from './service.js';
export var GetAvailableMobileLoyaltyReward;
(function (GetAvailableMobileLoyaltyReward) {
    function api(params) {
        const search = queryString(params, { skipNulls: true });
        return WebRequest.GET(`/patient/loyalty-rewards/available?${search}`);
    }
    GetAvailableMobileLoyaltyReward.api = api;
    function queryKey(params) {
        return QueryKeys.GetAvailableMobileLoyaltyReward(params);
    }
    GetAvailableMobileLoyaltyReward.queryKey = queryKey;
    function query(client, params) {
        return {
            queryFn: () => client.execute(api(params)),
            queryKey: queryKey(params),
        };
    }
    GetAvailableMobileLoyaltyReward.query = query;
})(GetAvailableMobileLoyaltyReward || (GetAvailableMobileLoyaltyReward = {}));
